export const SET_TOPICS = 'SET_TOPICS';
export const ADD_TOPIC = 'ADD_TOPIC';
export const SET_POSTS = 'SET_POSTS';
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';

export const setTopics = (topics) => ({
  type: SET_TOPICS,
  payload: topics,
});

export const addTopic = (topic) => ({
  type: ADD_TOPIC,
  payload: topic,
});

export const setPosts = (posts) => ({
  type: SET_POSTS,
  payload: posts,
});

export const addPost = (post) => ({
  type: ADD_POST,
  payload: post,
});

export const deletePost = (postId) => ({
  type: DELETE_POST,
  payload: postId,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});